import Constants from '../utils/consts';

var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function manageIntermediary(uname, token, id, eventId, brokerType, 
                                            name, logo, website, username, password, deleteFlag) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/manageIntermediary.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            resolve(JSON.parse(body.toString()));
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'id' : id,
        'eventId' : eventId,
        'brokerType' : brokerType,
        'name' : name,
        'logo' : logo,
        'website' : website,
        'username' : username,
        'password' : password,
        'deleteFlag' : deleteFlag,
    });

        req.write(postData);

        req.end();

        
    });
}
